import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'cigna-resizeable-height-container',
  templateUrl: './resizeable-height-container.component.html',
  styleUrls: ['./resizeable-height-container.component.css'],
})
export class ResizeableHeightContainerComponent {
  @Output() heightChange = new EventEmitter();

  @Input()
  get height(): number {
    return this._height;
  }
  set height(val: number) {
    if (this._height !== val) {
      this._height = val;
    }
  }
  private _height = 250;

  private _screenYStart = 0;

  drag(event: DragEvent) {
    // last drag event that fires when mouse released the offset jumps weirdly, so this prevents that
    if (!event.screenX && !event.screenY) {
      return;
    }
    // for everyone but FF we can update size on drag
    if (event.offsetY !== 0) {
      // for non FF browsers clear screenYStart, this way height calc will be ignored on dragEnd since we have already done it real time
      this._screenYStart = 0;
      this.height = this.height + event.offsetY;
      this.heightChange.emit(this.height);
    }
  }

  dragStart(event: DragEvent | any) {
    // for FF
    event.dataTransfer.setData('text/plain', 'some_dummy_data');
    const dummyImage = document.createElement('img');
    dummyImage.src =
      'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    event.dataTransfer.setDragImage(dummyImage, 0, 0);

    // set initial offset variable based on screenY we can use in combination with dragend screenY to calculate offsetY
    this._screenYStart = event.screenY;
  }

  dragEnd(event: DragEvent) {
    // for FF calculate offset using screenYStart and screenY from dragEnd, essentially replicates whats missing in offsetY on drag
    if (this._screenYStart !== 0) {
      this.height = this.height + (event.screenY - this._screenYStart);
      this.heightChange.emit(this.height);
    }
  }
}
